import React from 'react'
import styles from './montaje.module.scss'
import GarantiaIcon from './assets/garantia_icon.svg'
import { t } from '../../../../../common/i18n'

interface Props {
  anys?: number
}

const Garantia: React.FC<Props> = ({ anys }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.price_header}>
        <GarantiaIcon />
        <span className={styles.price_label}>
          &nbsp;{t('catalogo.producto.ficha.garantia', { x: anys || '2' })}
        </span>
      </div>
    </div>
  )
}

export default Garantia
